import Modal from "bootstrap.native/dist/components/modal-native.esm";
import IMask from "imask";
import Litepicker from "litepicker";
import loadStylesheet from "./loadStylesheet";
import "./focusOnError.js";

// Contact Form Modal
// let contactTrigger = document.getElementById("contactTrigger");
let contactTriggers = document.querySelectorAll('.contact_trigger');

// if (contactTrigger) {
if (contactTriggers.length) {
    contactTriggers.forEach(element => {

        let contactModal = new Modal(element);
        let modalContainer = document.getElementById("contact");

        if (showContactModal) {
            loadStylesheet();
            contactModal.show();
        }

        let loadRecaptchaScript = () => {
            if (typeof googleRecaptchaSrc !== "undefined" && typeof googleRecaptchaLoaded != "undefined" && !googleRecaptchaLoaded) {
                let s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = googleRecaptchaSrc;
                let x = document.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);

                googleRecaptchaLoaded = true;
            }
        };

        modalContainer.addEventListener("show.bs.modal", e => {
            loadRecaptchaScript();
        });

        modalContainer.addEventListener("hide.bs.modal", e => {
            if (!!picker) picker.hide();
        });

    });
}

// Phone Number Mask
let phoneInut = document.getElementById("phone");
if (phoneInut) {
    let maskOptions = {
        mask: "(000) 000-0000"
    };
    IMask(phoneInut, maskOptions);
}

// Date Range Picker
let dateField = document.getElementById("shooting_date");
let picker;
if (dateField) {
    picker = new Litepicker({
        element: dateField,
        format: "D MMM, YYYY",
        numberOfMonths: 2,
        numberOfColumns: 2,
        selectForward: false,
        selectBackward: false,
        splitView: false,
        inlineMode: false,
        singleMode: false,
        autoApply: true,
        showWeekNumbers: false,
        showTooltip: true,
        disableWeekends: false,
        mobileFriendly: true
    });
}

